import "amazon-connect-streams";
import voiceConnectionToParticipant from "./voiceConnectionToParticipant";

function getParticipantVoiceConnections(contact: connect.Contact) {
    const { connectionId: agentConnectionId } = contact.getAgentConnection();
    const { connectionId: initialConnectionId } = contact.getInitialConnection();
    const voiceConnections = contact
        .getConnections()
        .filter((connection) => connection instanceof connect.VoiceConnection);

    return voiceConnections.filter(
        (connection) =>
            connection.connectionId !== agentConnectionId && connection.connectionId !== initialConnectionId,
    );
}

export function contactToParticipants(contact: connect.Contact) {
    const voiceConnections = getParticipantVoiceConnections(contact);
    return voiceConnections.map(voiceConnectionToParticipant);
}

export function contactToQuickConnectConnections(contact: connect.Contact) {
    const voiceConnections = getParticipantVoiceConnections(contact);

    // Filter out any non-Quick Contacts
    return voiceConnections.filter((connection) => connection.getQuickConnectName() !== null);
}
